import { DEFAULT_CLIPPING_MEDIAS_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

/**
 * @returns {import('../types').FetchDefaultClippingMediaAction}
 */
export const fetchDefaultClippingMedia = () => ({
  type: types.FETCH_FLEETBACK_MEDIAS_CLIPPING_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: DEFAULT_CLIPPING_MEDIAS_URL,
    },
  },
});

/**
 * @param {Array<import('modules/medias/types/abstract-media').AbstractMedia>} medias
 * @returns {import('../types').FetchDefaultClippingMediaSuccessAction}
 */
export const fetchDefaultClippingMediaSuccess = medias => ({
  type: types.FETCH_FLEETBACK_MEDIAS_CLIPPING_SUCCESS,
  payload: medias,
});

/**
 * @param {string} error
 * @returns {import('../types').FetchDefaultClippingMediaFailureAction}
 */
export const fetchDefaultClippingMediaFailure = error => ({
  type: types.FETCH_FLEETBACK_MEDIAS_CLIPPING_FAILURE,
  payload: error,
  error: true,
});
